import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import moment from 'moment'
import InfiniteScroll from 'redux-infinite-scroll-sf'

import HistoryItem from './HistoryItem'
import Caption1 from '../../typography/captions/Caption1'

import { fetchQuestHistory } from '../../../actions/quest'
import { shouldHideHistoryEvent } from '../../../utils/questhistory'

const StyledHistoryList = styled.ul`
  li:nth-child(even) {
    background: #ffffff;
  }

  li:nth-child(odd) {
    background: #f8f8f8;
  }

  li.history-item {
    &:last-child .history-dots {
      display: none;
    }
  }
`

const NoQuestHistory = styled(Caption1)`
  background: #f8f8f8;
  padding: 17px 35px;
`

class HistoryList extends React.Component {
  constructor() {
    super()
    this.loadMoreEventsBound = this.loadMoreEvents.bind(this)
  }

  render() {
    const { events, quest } = this.props
    const createdBeforeHistoryLogStart =
      quest.created_at < moment('2018-09-11').unix()
    let items =
      events.length > 0 ? (
        events.map(event => (
          <HistoryItem
            event={event}
            dispatch={this.props.dispatch}
            quest={quest}
            hideItem={shouldHideHistoryEvent(event)}
          />
        ))
      ) : (
        <NoQuestHistory>
          Quest History not available prior to 11 September 2018
        </NoQuestHistory>
      )

    // add "no history prior to..." if quest created before logging start date
    if (
      events.length > 0 &&
      createdBeforeHistoryLogStart &&
      this.props.total === events.length
    ) {
      items = items.concat(
        <li style={{ marginBottom: '0', height: '50px' }}>
          <NoQuestHistory
            style={{ background: 'inherit', padding: '17px 35px 0' }}
          >
            Quest History not available prior to 11 September 2018
          </NoQuestHistory>
        </li>
      )
    }

    return (
      <StyledHistoryList>
        <InfiniteScroll
          items={items}
          loadingMore={this.props.isFetchingQuestHistory}
          loadMore={this.loadMoreEventsBound}
          elementIsScrollable={false}
          showLoader={false}
          threshold={10}
        />
      </StyledHistoryList>
    )
  }

  loadMoreEvents() {
    // Only load more history events if the size of the history event
    // list is less than the total count from the search call
    if (this.props.events.length < this.props.total) {
      this.props.dispatch(fetchQuestHistory(this.props.page + 1))
    }
  }
}

HistoryList.propTypes = {
  events: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  isFetchingQuestHistory: PropTypes.bool.isRequired,
  quest: PropTypes.object.isRequired
}

export default HistoryList



// WEBPACK FOOTER //
// ./src/components/quest/questhistory/HistoryList.js